import { InputAdornment } from '@mui/material';
import RequiredIcon from '../RequiredIcon';
import CheckIcon from '@mui/icons-material/Check';

import './AdornmentValidator.css';

interface AdornmentValidatorProps {
  checked: boolean
}
const AdornmentValidator:React.FC<AdornmentValidatorProps> = ({ checked }) => {
  return (
    <InputAdornment className="AdornmentValidator" position="end">
      {checked
        ? <CheckIcon sx={{ color: '#006c5b87' }} />
        : <RequiredIcon />
      }
    </InputAdornment>
  );
};

export default AdornmentValidator;
